<!--
 * @Author: 张国欣
 * @Date: 2024-10-20 19:17:01
 * @LastEditors: cnb zhangguoxin19@crpcg.com
 * @LastEditTime: 2026-05-23 00:02:38
 * @FilePath: /survey_frontend/src/view/extResult.vue
 * @Description: 
-->
<template>
  <div class="container">
    <Confetti :show="answerStatus === 'S'" :duration="4000" />
    <img src="@/assets/mp_qr.jpg" class="happy">
    <h3 class="tips" >关注公众号获取更多问卷</h3>
    <template v-if="answerStatus === 'S'" >
      <h3 class="congratulations" >恭喜您</h3>
      <p class="desc" v-if="scoreBonus">积分奖励：{{ scoreBonus }} </p>
    </template>
    <div class="scale-host" :style="{ height: hostHeight ? hostHeight + 'px' : 'auto' }">
      <div class="scale-wrap" ref="scaleWrap" :style="{ transform: 'scale(' + scale + ')' }">
        <p class="desc desc-highlight" v-if="questionnaireTitle">问卷标题：{{ questionnaireTitle }} </p>
        <p class="desc desc-highlight" v-if="answerStatus === 'S' || answerStatus === 'J' || answerStatus === 'R'">答题码：{{ extAnswerStr }} </p>
        <p class="desc desc-highlight">{{submitStatusMap[answerStatus]}}</p>
      </div>
    </div>

  </div>
</template>
<script>
import { getParams } from '../utils/index'
import { getUserAnswer } from '../api/index'
import Confetti from '../components/Confetti/index.vue'
export default {
  name: 'extResult',
  components: {
    Confetti
  },
  data () {
    return {
      extAnswerStr: '', // 外部推广答题码，用于前端展示
      answerIdentifier: '', // 答题令牌 暂时用不上
      answerStatus: '', // S-提交成功，D-被甄别，F-配额满
      scoreBonus: 0, // 积分奖励
      questionnaireTitle: '', // 问卷标题
      scale: 1, // 缩放比例 = window.innerWidth / 375
      hostHeight: 0, // 占位宿主高度（缩放后实际高度）
      submitStatusMap: {
        P: '进行中，请稍后查看结果',
        S: '已成功完成',
        J: '已成功完成',
        R: '已成功完成',
        D: '对不起，被甄别',
        F: '对不起，配额已满',
        U: '未知错误',
      }
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.calcScale()
    window.addEventListener('resize', this.calcScale)
    // 监听内容尺寸变化（数据加载完成后重新计算宿主高度）
    if (window.ResizeObserver) {
      this.ro = new window.ResizeObserver(() => {
        this.updateHostHeight()
      })
      this.ro.observe(this.$refs.scaleWrap)
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcScale)
    if (this.ro) this.ro.disconnect()
  },
  methods: {
    calcScale () {
      this.scale = window.innerWidth / 375
      this.updateHostHeight()
    },
    updateHostHeight () {
      const wrap = this.$refs.scaleWrap
      if (!wrap) return
      // offsetHeight 为未缩放的自然高度，乘以 scale 得到实际占位高度
      this.hostHeight = wrap.offsetHeight * this.scale
    },
    init () {
      this.extAnswerStr = getParams('extAnswerStr')
      this.$nextTick(() => {
        this.doGetUserAnswer()
      })
      // this.answerIdentifier = getParams('answerIdentifier')
      // this.answerStatus = getParams('answerStatus')
    },
    async doGetUserAnswer () {
      let params = {
        param: {
          extAnswerStr: this.extAnswerStr,
        }
      }
      let res = {}
      try {
        res = await getUserAnswer(params)
        this.$toast.loading('加载中', { duration: 0 });
        if (res.code === '0000' && res.result) {
          this.$toast.hide()
          const resData = res.result
          const { answerIdentifier, answerStatus, scoreBonus, questionnaireTitle } = resData
          this.answerIdentifier = answerIdentifier
          this.answerStatus = answerStatus
          this.scoreBonus = scoreBonus
          this.questionnaireTitle = questionnaireTitle
        } else {
          this.$toast.hide()
          this.$toast.info(res.message)
          console.log('活动火爆，请稍后重试')
        }
      } catch (err) {
        this.$toast.hide()
        console.log('err:', err)
      }
    },
  }
}
</script>
<style scoped>
.container{
  text-align: center;
}
img.happy{
  width: 60%;
  margin-bottom: 6px;
  margin-top: 20px;
}
h3.tips{
  margin-bottom: 20px;
}
.desc{
  padding: 4px 40px;
  word-break: break-all;
  overflow-wrap: break-word;
}
.desc-highlight{
  font-size: 2em;
  font-weight: bold;
}
.scale-host{
  width: 100%;
  overflow: hidden;
}
.scale-wrap{
  width: 375px;
  /* 钉死字号上下文，不受 index.html 中随屏宽变化的根字号影响，
     保证 375 容器内换行点在任意屏宽下完全一致，再由 transform: scale 整体缩放铺满 */
  font-size: 14px;
  transform-origin: top left;
}

</style>